export default function AboutSection() {
  return (
    <section id="sobre" className="py-20 md:py-28 bg-white relative overflow-hidden">
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-32 h-64 hidden lg:block">
        <div className="grid grid-cols-4 gap-3">
          {Array.from({ length: 32 }).map((_, i) => (
            <div key={i} className="w-1.5 h-1.5 rounded-full bg-donnos-green/40" />
          ))}
        </div>
      </div>

      <div className="w-full px-4 md:px-8 lg:px-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20interior%20with%20employees%20working%20at%20computers%2C%20professional%20workspace%20with%20large%20monitors%20showing%20charts%20and%20data%2C%20clean%20modern%20design%2C%20natural%20light%20from%20windows%2C%20blue%20and%20neutral%20tones%2C%20technology%20company%20environment%2C%20editorial%20photography%20style&width=640&height=480&seq=donnos-about-office&orientation=landscape"
                alt="Equipe Donnos trabalhando"
                className="w-full h-auto object-cover rounded-2xl"
              />
            </div>

            <div className="absolute -bottom-6 -left-4 md:bottom-8 md:-left-8 bg-white rounded-xl px-6 py-5 shadow-xl border border-gray-100">
              <div className="flex items-center gap-2 mb-2">
                <div className="w-8 h-8 rounded-full bg-donnos-green/10 flex items-center justify-center">
                  <i className="ri-team-line text-donnos-green text-sm"></i>
                </div>
              </div>
              <div className="text-3xl font-bold text-gray-900 leading-none">6</div>
              <div className="text-sm font-medium text-gray-700 mt-1">Anos de experiência</div>
              <div className="mt-3 w-10 h-0.5 bg-donnos-green rounded-full" />
              <div className="mt-2 text-xs text-gray-500">Desde 2020</div>
            </div>
          </div>

          <div>
            <div className="flex items-center gap-3 mb-4">
              <p className="text-sm font-semibold text-donnos-green uppercase tracking-wider">
                SOBRE NÓS
              </p>
              <div className="w-8 h-0.5 bg-donnos-green rounded-full" />
            </div>
            <h2 className="text-2xl md:text-3xl lg:text-[42px] font-bold text-gray-900 mb-6 leading-tight">
              Sobre a{' '}
              <span className="text-donnos-green">Donnos</span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Fundada em 2020, a Donnos nasceu com o propósito de oferecer mais do que{' '}
              <strong className="text-gray-900">produtos: entregar uma experiência completa, segura e eficiente em tecnologia.</strong>
            </p>
            <p className="text-gray-600 leading-relaxed mb-4">
              Atuamos com vendas, serviços integrados e soluções sob medida para empresas, instituições e órgãos públicos, unindo tecnologia de informação e eletrônicos às soluções audiovisuais e contratos de manutenção e prestação de serviços.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Com sede em Brasília, nossa visão é crescer integrando tecnologia, atendimento humanizado e compromisso com a excelência.
            </p>
            <a
              href="https://wa.me/5511988730909"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 border-2 border-donnos-green text-donnos-green hover:bg-donnos-green hover:text-white font-semibold px-6 py-3 rounded-lg transition-colors"
            >
              <i className="ri-whatsapp-line"></i>
              Entrar em contato
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
